import { FC } from 'react'
import { Grid, Typography } from '@material-ui/core'

import useTranslate from '../../../i18n/useTranslate'

import MyTextfield from '../../../control/textfield/textfield'
import UploadDocFile from '../../web/shareUI/uploadDoc/UploadDocFile'
import { InitFilesT } from '../../../services/um/useApproveExResearcher'

interface InformationProps {
    initFiles: { uploadFileObj: InitFilesT }[]
}
const Information: FC<InformationProps> = ({ initFiles }) => {
    const translate = useTranslate()
    const topicInitial = [
        {
            id: 99,
            no: '',
            name_th: 'โครงการวิจัยและเอกสารที่เกี่ยวข้อง',
            name_en: 'Research projects and related documents',
            code: '',
            subtopic: [],
        },
    ]
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Typography variant="h5" style={{ fontWeight: 'bold' }}>
                    {translate.get('UM.APPROVE-RESEARCHER.USER-TITLE')}
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
                <MyTextfield
                    name="nameTH"
                    materialInputProps={{
                        label: translate.get('UM.APPROVE-RESEARCHER.NAME-TH'),
                        disabled: true,
                        placeholder: translate.get('UM.APPROVE-RESEARCHER.NAME-TH'),
                        size: 'medium',
                    }}
                    required
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <MyTextfield
                    name="nameEN"
                    materialInputProps={{
                        label: translate.get('UM.APPROVE-RESEARCHER.NAME-EN'),
                        disabled: true,
                        placeholder: translate.get('UM.APPROVE-RESEARCHER.NAME-EN'),
                        size: 'medium',
                    }}
                    required
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <MyTextfield
                    name="mobilePhone"
                    materialInputProps={{
                        label: translate.get('UM.APPROVE-RESEARCHER.TELEPHONE'),
                        disabled: true,
                        placeholder: translate.get('UM.APPROVE-RESEARCHER.TELEPHONE'),
                        size: 'medium',
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <MyTextfield
                    name="email"
                    materialInputProps={{
                        label: translate.get('UM.APPROVE-RESEARCHER.EMAIL'),
                        disabled: true,
                        placeholder: translate.get('UM.APPROVE-RESEARCHER.EMAIL'),
                        size: 'medium',
                    }}
                    required
                />
            </Grid>
            <Grid item xs={12} sm={12}>
                <MyTextfield
                    name="departments"
                    materialInputProps={{
                        label: translate.get('UM.APPROVE-RESEARCHER.DEPARTMENT'),
                        disabled: true,
                        placeholder: translate.get('UM.APPROVE-RESEARCHER.DEPARTMENT'),
                        size: 'medium',
                    }}
                    required
                />
            </Grid>
            <Grid item xs={12} sm={12}>
                <MyTextfield
                    name="departments_en"
                    materialInputProps={{
                        label: translate.get('UM.APPROVE-RESEARCHER.DEPARTMENT_EN'),
                        disabled: true,
                        placeholder: translate.get('UM.APPROVE-RESEARCHER.DEPARTMENT_EN'),
                        size: 'medium',
                    }}
                    required
                />
            </Grid>

            <Grid item xs={12}>
                <Typography variant="h5" style={{ fontWeight: 'bold' }}>
                    {translate.get('UM.APPROVE-RESEARCHER.REASON-TITLE')}
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <MyTextfield
                    name="reason"
                    materialInputProps={{
                        label: translate.get('UM.APPROVE-RESEARCHER.REASON'),
                        disabled: true,
                        placeholder: translate.get('UM.APPROVE-RESEARCHER.REASON'),
                        size: 'medium',
                        rows: 5,
                        multiline: true,
                    }}
                    required
                />
            </Grid>

            <Grid item xs={12}>
                <Typography variant="h6" style={{ fontWeight: 'bold' }}>
                    {translate.get('UM.APPROVE-RESEARCHER.FILES')}
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <UploadDocFile
                    documentTitleList={topicInitial}
                    initialData={initFiles as any}
                    isViewMode={true}
                    disabledBtn={true}
                />
            </Grid>
        </Grid>
    )
}

export default Information
